import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrinter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M23.9993 4C24.5121 4 24.9348 4.38604 24.9925 4.88338L24.9993 5L24.9983 9H26.3326C28.0026 9 29.3964 10.2316 29.4938 11.8219L29.4993 12V22C29.4993 22.5128 29.1132 22.9355 28.6159 22.9933L28.4993 23H24.9993V27.5C24.9993 28.0128 24.6132 28.4355 24.1159 28.4933L23.9993 28.5H7.99927C7.48643 28.5 7.06376 28.114 7.006 27.6166L6.99927 27.5V23H3.49927C2.98643 23 2.56376 22.614 2.506 22.1166L2.49927 22V12C2.49927 10.3843 3.83346 9.09505 5.48157 9.00502L5.66593 9H6.99827L6.99925 5C6.99925 4.48716 7.38529 4.06449 7.88263 4.00673L7.99925 4H23.9993ZM22.999 20H8.999V26.5H22.999V20ZM5.66593 11H26.3326L26.4627 11.0061C27.0591 11.0625 27.4993 11.502 27.4993 12L27.499 21H24.9993V19L24.9925 18.8834C24.9348 18.386 24.5121 18 23.9993 18H7.99927L7.88265 18.0067C7.38531 18.0645 6.99927 18.4872 6.99927 19V21H4.499L4.49927 12L4.5059 11.8943C4.56733 11.4063 5.04861 11 5.66593 11ZM23.5 13C24.3284 13 25 13.6716 25 14.5C25 15.3284 24.3284 16 23.5 16C22.6716 16 22 15.3284 22 14.5C22 13.6716 22.6716 13 23.5 13ZM8.999 6H22.999L22.9983 9H8.99827L8.999 6Z"
	})
});
export default SvgPrinter;
